import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading } from "../slices/holidaySlice";
import * as services from "../services/configBesmartApi";
import { generateRandomString } from "utils/helper";
import { setBeleave } from "../slices/attendanceSlice";
import { Alert, message, Modal } from "antd";
import { useTranslation } from "react-i18next";

function useBeleave() {
  const dispatch = useDispatch();
  const { currentCompany, currentEmployee, } = useSelector((state) => state.company);
  const { beleave } = useSelector((state) => state.attendance);
  const { t } = useTranslation();
  function toInitialValues(data = {}) {
    const submenu = data?.[0]?.submenu || [];
    const modifiedValues = {
      menuCodeBeleave: data?.[0]?.statusFlag === "Y",
      switchleaverequest: submenu.find(m => m.menuCode === "LEAVE")?.statusFlag === "Y",
      switchovertime: submenu.find(m => m.menuCode === "OVERTIME")?.statusFlag === "Y",
      switchoutside: submenu.find(m => m.menuCode === "OFFSITE")?.statusFlag === "Y",
      switchtimerequest: submenu.find(m => m.menuCode === "ENDORSETIME")?.statusFlag === "Y",
    };
    return modifiedValues;
  }

  function toParams(values = {}, menuList = []) {
    const beleave = menuList.find(menu => menu.menuCode === "BELEAVE");

    const newSubmenu = [
      { menuCode: "LEAVE", statusFlag: values.switchleaverequest ? "Y" : "N", index: 0 },
      { menuCode: "OVERTIME", statusFlag: values.switchovertime ? "Y" : "N", index: 1 },
      { menuCode: "OFFSITE", statusFlag: values.switchoutside ? "Y" : "N", index: 2 },
      { menuCode: "ENDORSETIME", statusFlag: values.switchtimerequest ? "Y" : "N", index: 3 },

    ];

    return {
      id: beleave?.id || null,
      menuCode: "BELEAVE",
      statusFlag: values?.menuCodeBeleave ? "Y" : "N",
      index: beleave?.index ?? 0,
      submenu: newSubmenu,
    };
  }

  const getBeleave = useCallback(async () => {
    try {
      dispatch(setIsLoading(true));
      const response = await services.getBesmartConfig({
        requestId: generateRandomString(),
        configType: "BELEAVE",
        companyId: currentCompany,
        actionId: currentEmployee,
      });
      dispatch(setBeleave(response.data?.content));
    } catch (error) {
    } finally {
      dispatch(setIsLoading(false));
    }
  }, [currentCompany, currentEmployee, dispatch]);
  const initialValues = useMemo(() => {
    return toInitialValues(beleave);
  }, [beleave]);

  const editBeleave = useCallback(
    (values) => {
      return new Promise((resolve, reject) => {
        Modal.confirm({
          title: t("dialog.confirmation.header"),
          content: (
            <span>{t("dialog.confirmation.edit_action")}</span>
          ),
          async onOk() {
            try {
              dispatch(setIsLoading(true));

              const menuList = beleave || [];
              const params = toParams(values, menuList);

              await services.editBesmartConfig({
                requestId: generateRandomString(),
                companyId: currentCompany,
                actionId: currentEmployee,
                menuList: params,
              });
              message.success(t("common.successsfull"));
              await getBeleave();
              resolve(true);
            } catch (error) {

              reject(error);
            } finally {
              dispatch(setIsLoading(false));
            }
          },
          onCancel() {
            resolve(false);
          },
        });
      });
    },
    [currentCompany, currentEmployee, dispatch, beleave, getBeleave, t]
  );

  useEffect(() => {
    getBeleave();
  }, [getBeleave]);

  return {
    getBeleave,
    beleave,
    initialValues,
    editBeleave,
  };
}

export default useBeleave;
